@if (stickerHTML) {
  <div class="sticker" [@simpleFadeAnimation]="'in'">
    <p [innerHTML]="stickerHTML"></p>
  </div>
}
